import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-article-share-bar/jb-article-share-bar.css.ts
var jb_article_share_bar_css_default = i`.title{font-family:var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}.title{font-size:var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-desktop-lineheight, 1.25rem)}:host{--social-icons-gap: 0;align-items:center;block-size:40px;display:flex;gap:var(--spacing-3xs);justify-content:flex-start}@media(min-width: 600px){:host{justify-content:flex-end}}.title{color:rgb(var(--theme-color-royal-blue));display:inline-block;text-transform:capitalize;user-select:none}`;

export {
  jb_article_share_bar_css_default
};
